import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TemplateLayout = ({ children }) => {
    return (_jsxs("div", { className: "flex flex-col min-h-screen h-full", children: [_jsx("div", { className: "w-full bg-white border-b border-gray-200", id: "template-layout-header" }), _jsx("div", { className: "py-4 px-6", children: children })] }));
};
export default TemplateLayout;
